<template>
    <CompassMenu
        v-if="hasSubMenu"
        ref="mainMenu"
        placement="bottom"
        trigger="hover"
        customClass="nav-item__add-menu"
    >
        <div class="nav-item__actions--item-link">
            <CompassFlag
                v-if="item.isNew"
                :label="$t.__('common.labels.tag.new')"
                size="small"
                class="nav-item__actions--item-link-flag"
            />
            <CompassIcon :icon="item.icon" class="nav-item__actions--item-icon" />
        </div>
        <template #dropdown>
            <CompassMenuSubtitle :label="translations.menuSubTitle" />
            <template v-for="subItem in itemSubMenu">
                <CompassMenuGroup
                    v-if="subItem.nestedItems && subItem.nestedItems.length > 0"
                    :key="`group-${subItem.txt}`"
                    :label="subItem.txt"
                    :icon="subItem.icon"
                    placement="right-start"
                    customClass="nav-item__add-menu-group"
                >
                    <NavItemAddIcon v-if="subItem.icon" :icon="subItem.icon" />
                    <span class="typographies-paragraph-medium-regular">{{ subItem.txt }}</span>
                    <template #dropdown>
                        <CompassMenuItem
                            v-for="subSubItem in subItem.nestedItems"
                            :key="`item-${subSubItem.txt}`"
                            :label="subSubItem.txt"
                            @click="handleMenuAction(subSubItem)"
                        />
                    </template>
                </CompassMenuGroup>
                <CompassMenuItem
                    v-else
                    :key="`direct-${subItem.txt}`"
                    :label="subItem.txt"
                    @click="handleMenuAction(subItem)"
                >
                    <template #prefixIcon>
                        <NavItemAddIcon v-if="subItem.icon" :icon="subItem.icon" />
                    </template>
                    <span class="typographies-paragraph-medium-regular">{{ subItem.txt }}</span>
                </CompassMenuItem>
            </template>
        </template>
    </CompassMenu>
    <a
        v-else
        :href="item.url"
        class="nav-item__actions--item-link"
        :class="{ 'nav-item__actions--item-link--no-hover': isAcademyItem }"
    >
        <CompassFlag
            v-if="item.isNew"
            :label="$t.__('common.labels.tag.new')"
            size="small"
            class="nav-item__actions--item-link-flag"
        />
        <MeltingSpotWidget v-if="isAcademyItem" decorative />
        <CompassIcon
            v-else
            :icon="item.icon"
            :class="[
                'nav-item__actions--item-icon',
                { 'nav-item__actions--item-icon--animated': isSponsorshipItem },
            ]"
        />
    </a>
</template>

<script>
import NavItemAddIcon from 'vcomponents/header/NavItemAddIcon.vue';
import MeltingSpotWidget from 'vcomponents/academy/MeltingSpotWidget.vue';

export default {
    components: {
        NavItemAddIcon,
        MeltingSpotWidget,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            translations: {
                menuSubTitle: this.$t.__('navbar.NavItem.menuSubTitle'),
            },
        };
    },
    computed: {
        itemSubMenu() {
            return this.item.sub || [];
        },
        hasSubMenu() {
            return this.itemSubMenu && this.itemSubMenu.length > 0;
        },
        isSponsorshipItem() {
            return this.item.id === 'sponsorship';
        },
        isAcademyItem() {
            return this.item.id === 'sellsyAcademy';
        },
    },
    methods: {
        handleMenuAction(item) {
            if (!item) {
                return;
            }
            if (item.url) {
                if (item.url.startsWith('http') || item.url.startsWith('/')) {
                    window.location.href = item.url;
                    return;
                }
                this.executeAction(item.url);
                return;
            }
            if (item.action && item.params !== undefined) {
                this.executeAction(item.action, item.params);
                return;
            }
        },
        executeAction(actionOrString, params = null) {
            if (typeof actionOrString === 'string' && actionOrString.includes('.')) {
                this.parseLegacyAction(actionOrString);
                return;
            }
            switch (actionOrString) {
                case 'createDocument':
                    if (window.DocTools && params) {
                        window.DocTools.createForThird(params.type, params.title);
                    }
                    break;
                case 'createThird':
                    if (window.Third && params) {
                        window.Third.create(params.type);
                    }
                    break;
                case 'editPeople':
                    if (window.People) {
                        window.People.edit();
                    }
                    break;
                case 'createOpportunity':
                    if (window.Opportunity) {
                        window.Opportunity.addOpportunity();
                    }
                    break;
                case 'createActivity':
                    if (window.Activities && params) {
                        window.Activities.openActivityForm(null, null, null, null, params.type);
                    }
                    break;
                default:
                    break;
            }
        },
        parseLegacyAction(actionString) {
            switch (true) {
                case actionString.includes('DocTools.createForThird'): {
                    const match = actionString.match(
                        /DocTools\.createForThird\('([^']+)',\s*'([^']*)'\)/,
                    );
                    if (match && window.DocTools) {
                        window.DocTools.createForThird(match[1], match[2]);
                    }
                    break;
                }
                case actionString.includes('Third.create'): {
                    const match = actionString.match(/Third\.create\('([^']+)'\)/);
                    if (match && window.Third) {
                        window.Third.create(match[1]);
                    }
                    break;
                }
                case actionString.includes('People.edit()'): {
                    if (window.People) {
                        window.People.edit();
                    }
                    break;
                }
                case actionString.includes('Opportunity.addOpportunity'): {
                    if (window.Opportunity) {
                        window.Opportunity.addOpportunity();
                    }
                    break;
                }
                case actionString.includes('Activities.openActivityForm'): {
                    const match = actionString.match(
                        /Activities\.openActivityForm\([^,]*,\s*[^,]*,\s*[^,]*,\s*[^,]*,\s*'([^']+)'\)/,
                    );
                    if (match && window.Activities) {
                        window.Activities.openActivityForm(null, null, null, null, match[1]);
                    }
                    break;
                }
                default:
                    break;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.nav-item {
    &__actions {
        position: relative;
        width: 28px;
        height: 28px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: var(--spacing-0);
        cursor: pointer;

        &--item {
            &-link {
                position: relative;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                gap: var(--spacing-0);
                border-radius: var(--spacing-0);
                cursor: pointer;
                width: 100%;
                height: 100%;

                &:hover:not(.nav-item__actions--item-link--no-hover) {
                    background-color: var(--colors-common-background-primary-subtle);
                }

                &-flag {
                    position: absolute;
                    top: 3px;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    z-index: 1;
                    font-size: var(--font-size-10);
                    line-height: var(--line-heights-12);
                    padding: 0 var(--spacing-0);
                }
            }
            &-icon {
                color: var(--colors-common-background-darkest-lighter);

                &--animated:hover .nav-item__actions--item-icon {
                    color: var(--colors-sellsy-coral-500);
                    animation: sponsorship-wiggle 1.2s ease-in-out infinite;
                }
            }
        }
    }
}

@keyframes sponsorship-wiggle {
    0% {
        transform: rotate(0deg);
    }
    12.5% {
        transform: rotate(-15deg);
    }
    25% {
        transform: rotate(0deg);
    }
    37.5% {
        transform: rotate(15deg);
    }
    50% {
        transform: rotate(0deg);
    }
    62.5% {
        transform: rotate(-15deg);
    }
    75% {
        transform: rotate(0deg);
    }
    87.5% {
        transform: rotate(15deg);
    }
    100% {
        transform: rotate(0deg);
    }
}
</style>

<style lang="scss">
.compass-menu__dropdown__container.nav-item__add-menu {
    z-index: 1000;
}
.compass-menu-group__dropdown__container.nav-item__add-menu-group {
    z-index: 1001;
}
</style>
